<template>
    <div v-cloak>
        <div class="row">
            <!-- Breadcrumb -->
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'home' }">{{ $t("inicio") }}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'configuracion' }">{{ $t("configuracion") }}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'clientes' }">{{ $t("clientes") }}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{ $t("previewTarjetasData") }}</li>
                    </ol>
                </nav>
            </div>
        </div>

        <div v-if="showFloatingBtn" class="floating-btn-container">
            <button class="floating-btn" @click="confirmarImportacion()">
                <i class="fa fa-upload"></i>
                {{ $t("importarData") }}
            </button>
        </div>

        <!-- Table Section -->
        <div class="col-md-14">
            <div class="card">
                <div class="table-responsive">
                    <table class="table table-bordered table-striped">
                        <thead class="thead-dark">
                            <tr>
                                <th v-for="(key, index) in headers" :key="index">{{ key }}</th>
                                <th>{{ $t("acciones") }}</th>
                            </tr>
                        </thead>
                        <tbody v-if="tarjetas.length > 0">
                            <tr v-for="(tarjeta, index) in tarjetas" :key="index">
                                <td v-for="(key, idx) in headers" :key="idx">
                                    {{ tarjeta[key] !== undefined && tarjeta[key] !== "" ? tarjeta[key] : "" }}
                                </td>
                                <td>
                                    <a class="btn btn-danger btn-link btn-xs" @click="editarTarjeta(index)">
                                        <i v-tooltip.top-center="$i18n.t('editar')" class="fas fa-pencil-alt"
                                            style="color: orange"></i>
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="100%">{{ $t("No existen datos o no se pudieron cargar") }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <!-- Modal Edit data -->
        <div v-if="showModal" class="modal-overlay" :adaptive="true" height="auto" :clickToClose="true">
            <div class="modal-content" @click.stop>
                <div class="modal-header">
                    <h5 class="modal-title title-bold">{{ $t("editarTarjeta") }}</h5>
                    <button class="close" @click="closeModal">&times;</button>
                </div>
                <div class="modal-body">
                    <div v-for="(value, key, index) in tarjetaEdit" :key="key" class="form-group">
                        <label :for="key">{{ key }}</label>
                        <input v-model="tarjetaEdit[key]" :id="key" class="form-control"
                            :type="isLastField(index) ? 'number' : 'text'" :disabled="!isLastField(index)" />
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-secondary" @click="closeModal">{{ $t("cancelar") }}</button>
                    <button class="btn btn-primary" @click="guardarEdiciones">{{ $t("guardar") }}</button>
                </div>
            </div>
        </div>

        <!-- Modal Confirm Importacion -->
        <div v-if="showConfirmacionImportacionModal" class="modal-overlay" :adaptive="true" height="auto"
            :clickToClose="true">
            <div class="modal-content" @click.stop>
                <div class="modal-header">
                    <h5 class="modal-title title-bold">{{ $t("confirmarImportacion") }}</h5>
                    <button class="close" @click="closeConfirmacionImportacion">&times;</button>
                </div>

                <div class="modal-body">
                    <p>{{ $t("seguroContinuarImportacion") }}</p>
                </div>

                <div class="modal-footer">
                    <button class="btn btn-secondary" @click="closeConfirmacionImportacion">{{ $t("cancelar")
                    }}</button>
                    <button class="btn btn-primary" @click="importarCambios">{{ $t("importarData") }}</button>
                </div>
            </div>
        </div>


        <!-- Importar cambios -->
        <div class="button-container">
            <button @click="confirmarImportacion()" class="btn import-btn">
                <i class="fa fa-upload"></i>
                {{ $t("importarData") }}
            </button>
        </div>

    </div>
</template>

<script>
import swal from "sweetalert2";
import { Loading } from 'element-ui';

export default {
    props: {
        datosTarjetas: {
            type: Array,
            default: () => [],
        },
        idCompany: {
            type: [String, Number],
            default: null,
        },
    },
    data() {
        return {
            loadingGeneral: null,
            tarjetas: [],
            headers: [],
            showModal: false,
            tarjetaEdit: {},
            showFloatingBtn: true,
            showConfirmacionImportacionModal: false,
        };
    },
    created() {
        if (this.datosTarjetas.length > 0) {
            // Limpiar las tarjetas con campos vacíos
            this.tarjetas = this.datosTarjetas.filter(tarjeta => {
                return !Object.values(tarjeta).some(value => value === null || value === "" || (typeof value === 'string' && value.trim() === ""));
            });

            // Configurar las cabeceras de la tabla
            this.headers = Object.keys(this.tarjetas[0] || {});
        }

        if (this.idCompany) {
            this.idCompany = this.idCompany;
        }

        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        // Eliminar el listener cuando el componente se destruya
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        isLastField(index) {
            return index === Object.keys(this.tarjetaEdit).length - 1;
        },
        editarTarjeta(index) {
            this.tarjetaEdit = { ...this.tarjetas[index] };
            this.showModal = true;
        },
        handleScroll() {
            const scrollPosition = window.scrollY;
            const pageHeight = document.documentElement.scrollHeight;
            const windowHeight = window.innerHeight;

            // Si el usuario está cerca del final de la página, ocultar el botón
            if (scrollPosition + windowHeight >= pageHeight - 150) {
                this.showFloatingBtn = false;
            } else {
                this.showFloatingBtn = true;
            }
        },
        guardarEdiciones() {
            const clave = Object.keys(this.tarjetaEdit)[0];
            const index = this.tarjetas.findIndex(tarjeta => tarjeta[clave] === this.tarjetaEdit[clave]);

            if (index !== -1) {
                this.tarjetas.splice(index, 1, { ...this.tarjetaEdit });
            }

            swal({
                position: "center",
                type: "success",
                title: 'Edición realizada',
                showConfirmButton: false,
                timer: 1000
            });

            this.closeModal();
        },
        closeModal() {
            this.showModal = false;
            this.tarjetaEdit = {};
        },
        confirmarImportacion() {
            this.showConfirmacionImportacionModal = true;
        },
        closeConfirmacionImportacion() {
            this.showConfirmacionImportacionModal = false;
        },
        importarCambios() {
            this.closeConfirmacionImportacion();
            this.loadingGeneral = Loading.service({ text: this.$t('importandoDatos') });

            var config = {
                params: {
                    jwt: this.$store.getters.jwt,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            var params = {
                idCompany: this.idCompany,
                listDatos: this.tarjetas,
            };

            let vm = this;
            let controller = "importarTarjetas";

            this.axios
                .post(
                    this.$store.getters.apiUrl + "clients/" + controller,
                    params,
                    config
                )
                .then(function (response) {
                    if (response.data.response) {
                        vm.loadingGeneral.close();
                        // Añadir que se hizo la importación correctamente y redigir
                        swal
                            .fire({
                                position: "center",
                                type: "success",
                                title: vm.$t('importacionRealizada'),
                                text: vm.$t('datosImportados'),
                                showConfirmButton: true,
                                confirmButtonText: vm.$t('aceptar'),
                            })
                            .then(() => {
                                // Redirigir al cerrar el swal
                                vm.$router.push({ name: "clientes" });
                            });
                    } else {
                        vm.loadingGeneral.close();
                        // console.log(response.data.message);

                        swal({
                            position: "center",
                            type: "error",
                            title: "Error al importar datos",
                            showConfirmButton: false,
                            timer: 1200
                        });
                    }

                })
                .catch(function (error) {
                    vm.loadingGeneral.close();
                    console.log(error);
                });
        },
    },
};
</script>

<style scoped>
[v-cloak] {
    display: none;
}

.card {
    padding: 20px;
}

tbody tr:hover {
    background-color: rgba(0, 153, 130, 0.2);
}

/* Modal */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal-content {
    background: white;
    padding: 20px;
    border-radius: 8px;
    width: 400px;
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-header .close {
    font-size: 1.5rem;
    cursor: pointer;
}

.modal-footer {
    display: flex;
    justify-content: space-between;
}

.modal-body .form-group {
    margin-bottom: 15px;
}

.button-container {
    display: flex;
    justify-content: center;
    align-items: center;
}

.import-btn {
    background-color: #101255;
    display: inline-flex;
    align-items: center;
    color: white;
    border: none;
    padding: 15px 30px;
    font-size: 16px;
    font-weight: bold;
    border-radius: 5px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease;
}

.import-btn i {
    margin-right: 10px;
}

.floating-btn i {
    margin-right: 10px;
}

.import-btn:hover {
    background-color: #0a0f3c;
    transform: scale(1.05);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
}

.import-btn:active {
    transform: scale(1);
    box-shadow: none;
}

.floating-btn-container {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 1000;
}

.floating-btn {
    background-color: #101255;
    display: inline-flex;
    align-items: center;
    color: white;
    border: none;
    padding: 15px 30px;
    font-size: 16px;
    font-weight: bold;
    border-radius: 5px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease;
    cursor: pointer;
}

.floating-btn:hover {
    background-color: #0a0f3c;
    transform: scale(1.05);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
}

.floating-btn:active {
    transform: scale(1);
    box-shadow: none;
}

.title-bold {
    font-weight: bold;
    font-size: 1.25rem;
    color: #333;
}
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Configuracion/Clientes/ImportarTarjetas.vue